// 商户后台主布局：侧栏 + 顶栏 + 内容区；代登录会话恒走正常模式并显示横幅（R86）
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useSetupFlags } from '@/auth/RequireSetup';
import { logout } from '@/api/auth';
import Sidebar from './Sidebar';
import Header from './Header';

/** 代登录横幅：仅 impersonated 会话渲染；退出复用既有 logout（无 refreshToken 亦干净回登录页） */
function ImpersonationBanner() {
  const [exiting, setExiting] = useState(false);

  const handleExit = async () => {
    if (exiting) {
      return;
    }
    setExiting(true);
    try {
      // logout 内部已 clearSession + 触发 onAuthFailure → navigate('/login')；失败也已清会话
      await logout();
    } catch {
      // 兜底：logout 失败也已清会话，忽略（与 Header.handleLogout 同范式）
    } finally {
      setExiting(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-6 py-2 flex items-center justify-between gap-4 shrink-0">
      <p className="text-sm text-amber-800">
        您正以平台管理员代登录身份访问，账户安全操作已禁用
      </p>
      <button
        type="button"
        onClick={() => void handleExit()}
        disabled={exiting}
        className="inline-flex items-center gap-1 rounded-lg border border-amber-300 bg-white px-2.5 py-1 text-xs font-medium text-amber-800 hover:bg-amber-100 transition-colors disabled:opacity-60"
      >
        <LogOut className="w-3.5 h-3.5" />
        {exiting ? '退出中…' : '退出代登录'}
      </button>
    </div>
  );
}

export default function Layout() {
  const { mustChangePassword, mfaSetupRequired, impersonated } = useSetupFlags();
  // 代登录会话豁免裸内容模式（R86）：未绑 TOTP/未改密的新账号两标志恒真，裸模式无导航无退出入口；
  // 后端已按 impersonatorAdminId 豁免 3412/3416 强制门禁，前端展示层对齐。普通会话判定零改动。
  if ((mustChangePassword || mfaSetupRequired) && !impersonated) {
    return (
      <div className="flex h-screen overflow-hidden">
        <main className="flex-1 overflow-y-auto bg-slate-50">
          <Outlet />
        </main>
      </div>
    );
  }
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        {impersonated && <ImpersonationBanner />}
        <main className="flex-1 overflow-y-auto bg-slate-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
